export const COLOR_TOOL_PALETTE = {
  black: '#212123',
  white: '#ffffff',
  grey: '#d8d4c8',
  greige: '#c3b8a5',
  hazelnut: '#bf8f6f',
  beige: '#edd1b9',
  yellow: '#ffea64',
  cream: '#fbf3a5',
  vanilla: '#fff9c7',
  peach: '#f9c9a5',
  ivory: '#fdeee4',
  pink: '#fad1ce',
  candy: '#f9d3e6',
  peony: '#efa0c6',
  fuchsia: '#e35192',
  red: '#d5181c',
  lavender: '#cfb5da',
  lilac: '#d6cde7',
  ice: '#dff2fd',
  sky: '#bce4fa',
  indigo: '#91a7d1',
  blue: '#436fbf',
  lake: '#7ce0d3',
  mint: '#d9ebe0',
  green: '#007032',
};

export enum COLOR_TOOL_OPTION_CHOICES {
  YES = 'YES',
  NO = 'NO',
};